import { useWorkspaceInfoRefetch } from '@modules/workspace/hooks/useWorkspaceInfoRefetch';
import { ReactNode, useEffect, useLayoutEffect, useRef } from 'react';
import { useWorkspaceInfoQuery } from '../../hooks/useWorkspaceInfoQuery';
import { WorkspaceInfoContext } from './context';
import { type WorkspaceInfoStoreApi, workspaceInfoFactory } from './factory';

export function WorkspaceInfoStoreProvider({
  children,
}: { children: ReactNode }) {
  const { refetchWorkspaceInfo } = useWorkspaceInfoRefetch();
  const storeRef = useRef<WorkspaceInfoStoreApi | null>(null);

  if (!storeRef.current) {
    storeRef.current = workspaceInfoFactory();
  }

  const { data, isLoading } = useWorkspaceInfoQuery();

  useEffect(() => {
    if (!isLoading && data) {
      storeRef.current!.getState().syncWorkspaceInfo(data);
    }
  }, [isLoading, data]);

  useLayoutEffect(() => {
    refetchWorkspaceInfo();
  }, [refetchWorkspaceInfo]);

  return (
    <WorkspaceInfoContext.Provider value={storeRef.current!}>
      {children}
    </WorkspaceInfoContext.Provider>
  );
}
